import { Injectable } from '@angular/core';
import {
  AbstractControl,
  AsyncValidatorFn,
  ValidationErrors,
} from '@angular/forms';

import { delay, map, Observable, of, switchMap } from 'rxjs';

import { OembedService } from '../services/oembed.service';

@Injectable({
  providedIn: 'root',
})
export class EmbeddableValidator {
  constructor(private readonly oembedService: OembedService) {}

  /**
   * Checks whether the given URL can be embedded using Oembed.
   *
   * This validator does not fail on empty values.
   * To fail on empty values, use the `required` and `notBlank` validators in combination with this one.
   */
  isEmbeddable: AsyncValidatorFn = (
    control: AbstractControl
  ): Observable<ValidationErrors | null> => {
    return of(control.value).pipe(
      delay(500),
      switchMap((value) =>
        value ? this.oembedService.isEmbeddable(value) : of(true)
      ),
      map((isValid) => (isValid ? null : { notEmbeddable: true }))
    );
  };
}
